// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	$w("#headerTransitionPoint").onViewportLeave(() => {
		$w("#scrollingHeaderStrip").show();
		$w("#defaultHeaderStrip").hide();
	})
	$w("#headerTransitionPoint").onViewportEnter(() => {
		$w("#defaultHeaderStrip").show();
		$w("#scrollingHeaderStrip").hide();
	})
});